var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "booking-rooms-overview container",
      class: [{ "--modify-booking-mode": _vm.isBookingEditMode }],
    },
    [
      _vm.isBookingEditMode && _vm.bookingReady
        ? _c(
            "div",
            [_c("modify-edit-banner", { attrs: { isRoomOverview: true } })],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "booking-rooms-overview-header" }, [
        _c("h6", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.tc("booking.roomOverviewTitle"))),
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "subtitle" }, [
          _vm._v(_vm._s(_vm.tc("booking.roomOverviewSubtitle"))),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "booking-rooms-overview-body" },
        _vm._l(_vm.itemsInCart, function (stay, i) {
          return _c("room-overview-card", {
            key: stay.id,
            attrs: { stay: stay, index: i + 1 },
          })
        }),
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }